import React from 'react';

const Register = () => {
  return (
    <svg
      version="1.1"
      id="register_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      style="enable-background:new 0 0 32 32;"
      space="preserve"
      style={{
        fill: 'currentColor',
        verticalAlign: 'middle',
      }}
    >
      <path d="M16.02,15.92c1.96-1.31,3.26-3.54,3.26-6.08c0-4.04-3.27-7.31-7.31-7.31c-4.04,0-7.31,3.27-7.31,7.31 c0,2.54,1.29,4.77,3.26,6.08C3.3,17.58,0,22,0,27.19c0,0.83,0.08,1.63,0.24,2.41l1.86-0.38v0c-0.13-0.66-0.2-1.33-0.2-2.03 c0-2.78,1.13-5.3,2.95-7.12c1.75-1.75,4.12-2.85,6.76-2.94c0.12,0.01,0.24,0.02,0.36,0.02c0.12,0,0.24-0.01,0.36-0.02	c2.64,0.09,5.02,1.2,6.76,2.94c1.82,1.83,2.95,4.34,2.95,7.12c0,0.7-0.07,1.38-0.2,2.03l1.86,0.38c0.16-0.78,0.24-1.59,0.24-2.41	C23.95,22,20.64,17.58,16.02,15.92z M8.15,13.66c-0.98-0.98-1.58-2.33-1.58-3.82c0-1.5,0.6-2.84,1.58-3.82 c0.98-0.98,2.33-1.58,3.82-1.58c1.5,0,2.84,0.6,3.82,1.58c0.98,0.98,1.58,2.33,1.58,3.82c0,1.5-0.6,2.84-1.58,3.82 c-0.9,0.9-2.11,1.48-3.46,1.56c-0.12,0-0.24-0.01-0.36-0.01c-0.12,0-0.24,0.01-0.36,0.01C10.26,15.13,9.05,14.56,8.15,13.66z" />
      <rect x="26.3" y="2.53" width="2.11" height="9.3" />
      <rect
        x="26.3"
        y="2.53"
        transform="matrix(6.123234e-17 -1 1 6.123234e-17 20.1694 34.5323)"
        width="2.11"
        height="9.3"
      />
    </svg>
  );
};

export default Register;
